import unified from 'unified';
import markdown from 'remark-parse';
function noop() {
    return true;
}
const processor = unified()
    .use(markdown, { commonmark: true, gfm: true })
    .use(function () {
    const Parser = this.Parser;
    // NOTE: Now, table syntax is disabled.
    // TODO: Implement table syntax.
    Parser.prototype.blockTokenizers.table = noop;
});
export const parse = (text) => processor.runSync(processor.parse(text));
//# sourceMappingURL=parse.js.map